import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import { themeConfig } from '../../config/theme.config'

const SectionTitle = ({ sectionTitle, alignSelf = 'center' }) => {
  const sectionTitleStyle = {
    fontSize: 22,
    alignSelf,
    marginBottom: 5,
    fontFamily: 'Roboto',
    fontWeight: 'heavy',
    color: themeConfig.semcogBlue1
  }

  return <Text style={[sectionTitleStyle]}>{sectionTitle}</Text>
}

export default SectionTitle

SectionTitle.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  alignSelf: PropTypes.string
}
